import { createContext, useContext } from "react";
import type { EditorConfig } from "./types";

const EditorConfigContext = createContext<EditorConfig | null>(null);

export function EditorConfigProvider({
  config,
  children,
}: {
  config: EditorConfig;
  children: React.ReactNode;
}) {
  return (
    <EditorConfigContext.Provider value={config}>
      {children}
    </EditorConfigContext.Provider>
  );
}

export function useEditorConfig(): EditorConfig {
  const config = useContext(EditorConfigContext);
  if (!config) {
    throw new Error("useEditorConfig must be used within EditorConfigProvider");
  }
  return config;
}
